import * as _ from "underscore";

import type UserWordStore from "stores/UserWordStore";

/**
 * Selects the initial set of words for a practice/flashcard session.
 *
 * Explicitly selected `specificWords` are always pinned to the front, in the
 * order given. The remaining slots (up to `sessionSize`) are filled from the
 * highest-priority candidates in server order, excluding any word already
 * pinned, then shuffled for display.
 *
 * Only this initial deck word-selection step is shared; each practice mode
 * still owns its own session mechanics.
 */
export const selectDeckWords = ({
  candidates,
  specificWords = [],
  sessionSize,
}: {
  candidates: UserWordStore[];
  specificWords?: UserWordStore[];
  sessionSize: number;
}): UserWordStore[] => {
  const pinnedIDs = new Set(specificWords.map((userWord) => userWord.id));
  const fillCandidates = candidates.filter(
    (userWord) => !pinnedIDs.has(userWord.id)
  );
  const fillCount = Math.max(0, sessionSize - specificWords.length);
  const fill = _.shuffle(_.first(fillCandidates, fillCount));

  return [...specificWords, ...fill];
};
